<template>
    <div>
        <el-row type="flex" justify="space-between">
            <el-col>相关团队</el-col>
            <el-col style="text-align: right;">
                <el-button type="text" size="mini" @click="addMemberHandle">添加成员</el-button>
                <el-button type="text" size="mini" @click="deleteMemberHandle">删除</el-button>
            </el-col>
        </el-row>
        <el-table
                ref="multipleTable"
                :data="tableData"

                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
            <el-table-column
                    :selectable="checkSelectable"
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="nickname"
                    label="姓名"
                    width="120">

            </el-table-column>
            <!--            <el-table-column-->
            <!--                    prop="team"-->
            <!--                    label="团队角色"-->
            <!--                    width="120">-->
            <!--            </el-table-column>-->
            <el-table-column
                    prop="phone"
                    label="手机号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column

                    label="权限"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch
                            :value="scope.row.mission=='rw'?true:false"
                            active-text="读写"
                            inactive-text="只读" @change="changeHandle(scope.row)">

                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
                title="添加团队成员"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose1"
        >
            <el-select v-model="value" filterable placeholder="请选择人员">

                <el-option
                        v-for="item in options"
                        :key="item.center_uid"
                        :label="item.nickname"
                        :value="item.center_uid">
                </el-option>
            </el-select>

            <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="handleClose">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: "team_custom",
  props: [
    'customHash',
    'tableData'
  ],
  data() {
    return {
      value1: true,
      dialogVisible: false,
      selectMember: [],
      value: '',
      options: [],
    }
  },
  methods: {
    handleClose1(){
      this.dialogVisible = false;
      this.value = ''
    },
    changeHandle(e){
      console.log(e)
      //TODO 修改客户团队成员权限
      if (e.mission === 'rw'){
        e.mission = 'r'
      }else {
        e.mission = 'rw'
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.$http({
        url: 'custom_union_add',
        data: {
          vip_custom_hash: this.customHash,
          uid_str: this.value
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          // this.tableData = res.data;
          this.value = ""
          this.$message({
            message: '添加成员成功',
            type: 'success'
          });
          this.tableData = res.data
          this.value = '';
        }
        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    },
    checkSelectable(row, index) {
      console.log(index)
      // if (index === 0) {
      //   return false
      // } else {
      //   return true
      // }
      return true;
    },
    handleSelectionChange(val) {
      console.log(val)
      this.selectMember = val
    },
    addMemberHandle() {
      this.dialogVisible = true;
      this.$http({
        url: 'user_index',
        data: {
          region_id: this.region,
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          // this.tableData = res.data;
          this.options = res.data.contact_list;

        }
        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    },
    //删除
    deleteMemberHandle() {
      console.log('删除')
      if (this.selectMember.length === 0) {
        this.$message({
          message: '请勾选删除人员',
          type: 'warning'
        });
        return
      } else {
        console.log('删除条目')
        var memberHash = []
        console.log(this.selectMember)
        for (const index in this.selectMember) {
          console.log(index)
          var dic = this.selectMember[index]
          memberHash.push(dic.union_uid);
        }


        this.$http({
          url: 'custom_union_del',
          data: {
            vip_custom_hash: this.customHash,
            delete_uid: memberHash.toString()
          },
        }).then(res => {
          if (res.code == 1) {
            console.log(res.data);
            // this.tableData = res.data;
            this.value = ""
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.tableData = res.data;
          }
          console.log(res);
        }).catch((err) => {
          console.log(err)
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
